const clean = (params = {}) => Object.fromEntries(Object.entries(params).filter(([, value]) => value !== "" && value != null));

const createPrintifyApi = ({ baseUrl, getToken }) => {
  const request = async (path, { method = "GET", body, params } = {}) => {
    const query = new URLSearchParams(clean(params)).toString();
    const token = typeof getToken === "function" ? getToken() : getToken;
    const response = await fetch(`${String(baseUrl || "").replace(/\/$/, "")}${path}${query ? `?${query}` : ""}`, {
      method,
      headers: { Accept: "application/json", "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.error || `HTTP ${response.status}`), { status: response.status, code: data.code });
    return data;
  };
  return {
    getPlatform: () => request("/dropshipping/printify/platform"),
    getConnection: () => request("/dropshipping/printify/connection"),
    getSignup: () => request("/dropshipping/printify/signup"),
    connect: (payload = {}) => request("/dropshipping/printify/connect", { method: "POST", body: payload }),
    testConnection: () => request("/dropshipping/printify/test-connection", { method: "POST" }),
    disconnect: () => request("/dropshipping/printify/disconnect", { method: "POST" }),
    refreshShops: () => request("/dropshipping/printify/shops/refresh", { method: "POST" }),
    selectShop: (shopId) => request("/dropshipping/printify/shops/primary", { method: "PATCH", body: { shopId } }),
    getSuppliers: () => request("/dropshipping/printify/suppliers"),
    getSupplierProducts: (supplierId, params) => request(`/dropshipping/printify/suppliers/${supplierId}/products`, { params }),
    getProducts: (params) => request("/dropshipping/printify/products", { params }),
    getProduct: (id) => request(`/dropshipping/printify/products/${id}`),
    importProduct: (payload) => request("/dropshipping/printify/products/import", { method: "POST", body: payload }),
    syncAll: () => request("/dropshipping/printify/sync", { method: "POST" }),
    syncProduct: (id) => request(`/dropshipping/printify/products/${id}/sync`, { method: "POST" }),
    getImportedProducts: (params) => request("/dropshipping/printify/imported-products", { params }),
    getOrders: (params) => request("/dropshipping/printify/orders", { params }),
    createSupplierOrder: (orderId, sellerId) => request(`/dropshipping/printify/orders/${orderId}/create`, { method: "POST", body: sellerId ? { sellerId } : {} }),
    syncOrder: (id) => request(`/dropshipping/printify/orders/${id}/sync`, { method: "POST" }),
    getErrors: () => request("/dropshipping/printify/errors"),
    getAdminOverview: () => request("/dropshipping/printify/admin/overview"),
    getAdminConnections: () => request("/dropshipping/printify/admin/connections"),
    updateAdminPlatform: (payload) => request("/dropshipping/printify/admin/platform", { method: "PATCH", body: payload }),
    syncAllSellers: () => request("/dropshipping/printify/admin/sync", { method: "POST" }),
    disableConnection: (id) => request(`/dropshipping/printify/admin/connections/${id}/disable`, { method: "PATCH" }),
  };
};

module.exports = { createPrintifyApi };
